import React from 'react';
import { Modal, Form, Button, Spin } from 'antd';
// Types
import { ListChannelMonetizationPrograms_listChannelMonetizationPrograms } from 'api/channelMonetization/types/ListChannelMonetizationPrograms';
import { ProgramFormValues } from './types';
// Hooks
import { useProgramForm } from './useProgramForm';
import { useSaveProgram } from './useSaveProgram';
// Components
import ProgramFormFields from './ProgramFormFields';
import MilestonesEditor from './MilestonesEditor';

type CreateEditProgramModalProps = {
  isVisible: boolean;
  isEdit: boolean;
  program: ListChannelMonetizationPrograms_listChannelMonetizationPrograms | null;
  onClose: () => void;
  onSaved: () => void;
};

const CreateEditProgramModal: React.FC<CreateEditProgramModalProps> = ({
  isVisible,
  isEdit,
  program,
  onClose,
  onSaved,
}) => {
  const { form, milestones, loadingMilestones, updateMilestone } =
    useProgramForm({ isVisible, isEdit, program });
  const { save, saving } = useSaveProgram();

  const handleSubmit = async () => {
    const values = (await form.validateFields()) as ProgramFormValues;
    const ok = await save({ values, milestones, isEdit, program });
    if (ok) {
      onSaved();
      onClose();
    }
  };

  const title = isEdit
    ? `Edit Program — ${program?.monthLabel ?? ''}`
    : 'Create Program';

  return (
    <Modal
      title={title}
      visible={isVisible}
      onCancel={onClose}
      width={640}
      destroyOnClose
      footer={[
        <Button key="cancel" onClick={onClose} disabled={saving}>
          Cancel
        </Button>,
        <Button
          key="submit"
          type="primary"
          loading={saving}
          onClick={handleSubmit}
        >
          {isEdit ? 'Save Changes' : 'Create Program'}
        </Button>,
      ]}
    >
      {isEdit && loadingMilestones ? (
        <Spin />
      ) : (
        <Form
          form={form}
          layout="vertical"
          name="channelMonetizationProgramForm"
          autoComplete="off"
        >
          <ProgramFormFields isEdit={isEdit} />
          <MilestonesEditor
            milestones={milestones}
            onChange={updateMilestone}
          />
        </Form>
      )}
    </Modal>
  );
};

export default CreateEditProgramModal;
